import { render, staticRenderFns } from "./InstrumentsBadgeList.vue?vue&type=template&id=80a9c34a&scoped=true&"
import script from "./InstrumentsBadgeList.vue?vue&type=script&lang=js&"
export * from "./InstrumentsBadgeList.vue?vue&type=script&lang=js&"
import style0 from "./InstrumentsBadgeList.vue?vue&type=style&index=0&id=80a9c34a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80a9c34a",
  null
  
)

export default component.exports